module.exports = __webpack_public_path__ + "static/img/5894d8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/xzlj/img/pic@3x.png
// module id = 707
// module chunks = 2